export default "__VITE_ASSET__44010e39__"